/* eslint-disable @typescript-eslint/explicit-function-return-type */
import styled from 'styled-components';
import {
  Container as RawContainer,
  size,
  typography,
  colors,
  mediaQueries,
  Accordion,
} from '@everlywell/leaves';

// Gatsby renders on the server and doesn't know what device will be viewing the page
// so we can't conditionally render sections based on mediaqueries in the component (i.e with useMediaQuery hook)
// that is why we use this CSS here show/hide sections which seems quite non-react
// https://github.com/gatsbyjs/gatsby/issues/2142#issuecomment-330027574
export const SecondaryContainerDesktop = styled(RawContainer)`
  display: none;
  ${mediaQueries.forTabletVerticalUp} {
    display: block;
    padding-top: ${size.lg}px;
    padding-bottom: ${size.xl4}px; /* matches SectionWrapper spacing */
  }
`;

export const SecondaryContainerMobile = styled(RawContainer)`
  display: block;
  ${mediaQueries.forTabletVerticalUp} {
    display: none;
  }
`;

export const SecondaryHeadline = styled.p`
  padding-bottom: ${size.md}px;
  ${typography.overlineText};
  color: ${colors.green6};
`;

export const SecondaryCTA = styled.a.attrs(props => ({
  onClick: props.onClick,
}))`
  background-color: white;
  display: block;
  padding: 13px 12px ${size.sm}px;
  text-align: center;
  box-shadow: 0 2px 20px -5px rgba(0, 0, 0, 0.12);
  ${typography.buttonText}
  color: ${colors.green5};
  max-width: 249px;
  width: 100%;
  text-decoration: none;
  ${mediaQueries.forDesktopUp} {
    font-size: 18px;
    padding-left: 0;
    padding-right: 0;
  }
  ${mediaQueries.forPhoneOnly} {
    margin-bottom: ${size.md}px;
    &:first-child {
      margin-top: 6px;
    }
    &:last-child {
      margin-bottom: 37px;
    }
  }
`;

export const SecondaryCTAText = styled.div`
  display: block;
  margin: 0 auto;
  /* make all CTA texts wrap to 2 lines */
  ${mediaQueries.forTabletVerticalUp} {
    max-width: ${size.xl5}px;
  }
  ${mediaQueries.forDesktopUp} {
    max-width: unset;
  }
`;

export const AccordionChildContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const AccordionHeading = styled(Accordion.Heading)`
  color: ${colors.green6};
`;
